import { render, staticRenderFns } from "./recipe_card.vue?vue&type=template&id=df72100e&scoped=true&lang=html&"
import script from "./recipe_card.vue?vue&type=script&lang=js&"
export * from "./recipe_card.vue?vue&type=script&lang=js&"
import style0 from "./recipe_card.vue?vue&type=style&index=0&id=df72100e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df72100e",
  null
  
)

export default component.exports